import React, { FC, memo, useMemo } from "react";

import { Container, ContainerAlias, ContainerValue } from "./styled";
import { ExpandableTitle } from "../components/ExpandableTitle/ExpandableTitle";
import { renderElement } from "../utils/renderElement";
import { isVisibleContainer } from "../utils/isVisibleContainer";
import { useWidgetContext } from "../../Dashboard/hooks/useWidgetContext";
import { useRelatedDataSourceAttributes } from "../hooks/useRelatedDataSourceAttributes";
import { ContainerProps } from "../types";

export const SlideshowContainer: FC<ContainerProps> = memo(({ config, elementConfig, type }) => {
  const { page, expandedContainers, selectedTabId, setSelectedTabId, dataSources } = useWidgetContext(type);
  const { attributes, layerInfo } = useRelatedDataSourceAttributes({ config, elementConfig, dataSources });

  const { id, options } = elementConfig || {};
  const { expandable, expanded } = options || {};
  const isVisible = isVisibleContainer(id, expandable, expanded, expandedContainers);

  const render = useMemo(
    () =>
      renderElement({
        config,
        elementConfig,
        attributes,
        layerInfo,
        expandedContainers,
        selectedTabId,
        setSelectedTabId,
        page,
        type,
      }),
    [config, elementConfig, attributes, layerInfo, expandedContainers, selectedTabId, setSelectedTabId, page, type],
  );

  return (
    <>
      <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={render} />
      {isVisible && (
        <Container style={elementConfig?.style}>
          <ContainerAlias hasBottomMargin>{render({ id: "alias" })}</ContainerAlias>
          <ContainerValue>{render({ id: "slideshow", wrap: false })}</ContainerValue>
        </Container>
      )}
    </>
  );
});
